module.exports = __webpack_public_path__ + "img/world_vision_icon2.e2f7f91b.svg";